/* eslint-disable arrow-body-style */
import { AxiosError, AxiosResponse } from 'axios';
import { ResponseStatusModel } from '../store/response-status/ResponseStatusModel';
import SnackbarUtil from '../utils/SnackbarUtil';
import { axiosInstance } from '../utils/axiosConfig';

const RESERVATIONS_URL = '/api/reservations';

export const postReservationAdapter = (formData: FormData): Promise<ResponseStatusModel> => {
  return axiosInstance
    .post(RESERVATIONS_URL, formData)
    .then((response: AxiosResponse<ResponseStatusModel>): ResponseStatusModel => {
      response.data.status === 'ok'
        ? SnackbarUtil.success(response.data.message)
        : SnackbarUtil.error(response.data.message);
      return response.data;
    })
    .catch((error: AxiosError): ResponseStatusModel => {
      SnackbarUtil.error(error.message);
      return { status: String(error.status), message: error.message };
    });
};
